import styled from 'styled-components/macro';
import PropTypes from 'prop-types';

const Clamp = styled.span`
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: ${props => props.lines};
  -webkit-box-orient: vertical;
  word-break: break-word;
`;

Clamp.propTypes = {
  lines: PropTypes.number,
};

Clamp.defaultProps = {
  lines: 2,
};

export default Clamp;
